import { TimelineOptions } from "vis-timeline/esnext";

export const options: TimelineOptions = {
  orientation: "top",
  verticalScroll: true,
  showCurrentTime: false,
  groupOrder: function (a, b) {
    if (a.id === TimelineGroupConstants.VideoBuffer) {
      return -1;
    }
    if (b.id === TimelineGroupConstants.VideoBuffer) {
      return 1;
    }

    const trackA = parseInt(a.id.match(/\d+/), 10);
    const trackB = parseInt(b.id.match(/\d+/), 10);

    return trackA - trackB;
  },
  groupHeightMode: "fixed",
  zoomMin: 1000, // 1 second in milliseconds
  zoomMax: 1000 * 60 * 10, // 10 mins in milliseconds
  maxMinorChars: 7,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  snap: function (date, _scale, _step) {
    // TODO: resolution should by dynamic depending on zoom
    const resolution = 10; // ms
    return Math.round(date.getTime() / resolution) * resolution;
  },
  format: {
    minorLabels: {
      millisecond: "SSS[ms]",
      second: "s[s]",
    },
  },
  margin: {
    axis: 0,
    item: 0,
  },
  stack: false,
  horizontalScroll: true,
  zoomKey: "shiftKey",
  zoomFriction: 50,
  moveable: true,
};

export type TimelineItemView =
  | "timeline-item-track"
  | "timeline-item-event-range"
  | "timeline-item-event";

export const TIMELINE_ITEM_VIEW = {
  TRACK: "timeline-item-track" as const,
  EVENT_RANGE: "timeline-item-event-range" as const,
  EVENT: "timeline-item-event" as const,
};

export enum TimelineGroupConstants {
  VideoBuffer = "videoBuffer",
  TimeRange = "timeRange",
}
